import { prescriptionHasAdd } from "./prescriptionExtract";

function lensType(value = "") {
  const text = String(value).toLowerCase().replace(/[_-]/g, " ");
  if (/\bbifocals?\b/.test(text)) return "bifocal";
  if (/\bprogressive\b/.test(text)) return "progressive";
  if (/\breading\b/.test(text)) return "reading";
  if (/\bsingle\s*vision\b/.test(text)) return "single vision";
  return "";
}

// Preview only: the server recomputes and persists concerns on confirmation.
// Use the current Shopify bundle, never a stale PDF bundle after selection changes.
export function buildReviewPrescriptionConcerns({ bundle, prescription = {}, hasFile = false } = {}) {
  if (!bundle || !Array.isArray(bundle.items)) return [];
  const lineItems = bundle.items.map(item => ({
    title: item.shopify?.title || item.name || item.label || "",
    productType: item.productType || item.shopify?.productType || "",
    sku: item.sku || "",
  }));
  const hasLensItem = lineItems.some(item => {
    const text = `${item.productType} ${item.title} ${item.sku}`.toLowerCase();
    if (/sunglass/.test(text)) return false;
    return /^(lens|lenses|lensadvizor|lensadvisor)$/i.test(item.productType)
      || /\b(clear|blf|lenses?)\b|\b(basic|premium)[-_\s]?lens\b/.test(text);
  });
  const hasValue = value => value !== null && value !== undefined && value !== "";
  const hasRx = hasFile || [prescription.od, prescription.os].some(eye =>
    eye && [eye.sphere ?? eye.sph, eye.cylinder ?? eye.cyl, eye.axis, eye.add].some(hasValue)
  ) || Boolean(prescription.pdType || prescription.pdDistance || prescription.singularPd
    || prescription.pdOd || prescription.pdOs || prescription.od?.pd || prescription.os?.pd);
  const concerns = [];
  if (hasRx && !hasLensItem) {
    concerns.push({ code: "PRESCRIPTION_WITHOUT_ORDERED_LENS",
      message: "A prescription was provided, but the ordered bundle has no lens item. Distributor review is required; the ordered products have not been changed." });
  }
  // A UI-selected prescription type is not evidence of the extracted Rx type.
  const suppliedType = lensType(prescription.extractMeta?.inferredLensType);
  const types = [...new Set(lineItems.map(item => lensType(item.title)).filter(Boolean))];
  for (const orderedType of types) {
    if (suppliedType && suppliedType !== orderedType) {
      concerns.push({ code: "LENS_TYPE_MISMATCH",
        message: `Ordered lens type: ${orderedType}. The prescription was identified as ${suppliedType}. Please verify the original prescription and resolve the discrepancy before approving the order.` });
    } else if (orderedType === "single vision" && prescriptionHasAdd(prescription)) {
      concerns.push({ code: "ADD_WITH_SINGLE_VISION",
        message: "Single vision lenses were ordered, but the supplied prescription includes ADD. This may be intentional; the distributor must verify it before approving the order. No lens type or prescription value has been changed." });
    }
  }
  return concerns;
}
